

// import Swal from 'sweetalert2'; // นำเข้า SweetAlert2
// import { useNavigate } from 'react-router-dom';
// import Footer from '../navbarv2/footer';
// import React, { useState, useEffect } from 'react';
// import './listbooking.css';
// import Navbar from '../navbarv2/navbar';
// import Zpotlogo from '../img/ZPOT_LOGO.png';
// import imgzoos from '../model/imgmodel';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
// import { Link } from 'react-router-dom';
// import { API_ENDPOINT } from '../auth/config';
// import { formatDate } from '../FormatDate/formatDate';
// function OrderItem({ order }) {
//   let statusText;
//   let statusColor;
//   const getStatusLink = (status) => {
//     switch (status) {
//       case 'approved':
//         return (
//           <Link
//             key={order.id}
//             to="/ticketpostpone"
//             state={{ id: order.id, postpone: order.postpone,ref1: order.ref1,ref2: order.ref2,status: order.status, ticketstatus: order.action }}
//             onClick={(e) => {
//               if (order.action === "active" || order.status === "cancel") {
//                   e.preventDefault(); // ป้องกันการนำทาง
//               }
//           }}
//             className={` ${order.action === "finished" || order.status === "cancel" ? "disabledorder" : ""}`} 
//           >
//              ดูรายการ
         
//             <FontAwesomeIcon
//               icon={faAngleRight}
//               className={`icon mx-0 px-0 mx-md-0 px-md-0 d-none d-sm-inline ${order.action === "finished" || order.status === "cancel" ? "disabledorder" : ""}`} 
//             />
//           </Link>
//         );
//       case 'pending':
//         return (
//           <Link 
//             key={order.id}
//             to="/ticketpostpone"
//             state={{ id: order.id,ref1: order.ref1,ref2: order.ref2,status: order.status , ticketstatus: order.action}}
//             onClick={(e) => {
//               if (order.action === "active" || order.status === "cancel") {
//                   e.preventDefault(); // ป้องกันการนำทาง
//               }
//           }}
//             className={`status text-primary ${order.action === "finished" || order.status === "cancel" ? "disabledorder" : ""}`} 
//           >
//             ดูรายการ
//             <FontAwesomeIcon
//               icon={faAngleRight}
//               className={`icon mx-0 px-0 mx-md-0 px-md-0 d-none d-sm-inline ${order.action === "finished" || order.status === "cancel" ? "disabledorder" : ""}`} 
             
//             />
//           </Link>
//         );
//       case 'cancel':
//         return null;
//       default:
//         return null;
//     }


//   };

//   let zooImg;
//   let zooname;
//   if (order.zoo_id !== null) {
//     const foundZoo = imgzoos.find((item) => item.id === order.zoo_id);
//     zooImg = foundZoo ? foundZoo.img : null;
//     zooname = foundZoo ? foundZoo.name : null;
//   } else {
//     zooImg = 'https://placeholder.com/150';
//     zooname = 'องค์การสวนสัตว์แห่งประเทศไทย';
//   }




//   switch (order.action) {
//     case null:
//       statusText = "ยังไม่มีการทำรายการ";
//       statusColor = "MediumSeaGreen"; // สีเขียว
//       break;
//     case "active":
//       statusText = "รายการแสกนเข้าใช้งาน";
//       statusColor = "Orange"; // สีเหลือง
//       break;
//     case "finished":
//       statusText = "รายการใช้งานแล้ว";
//       statusColor = "red"; // สีแดง
//       break;
//     default:
//       statusText = "สถานะไม่ทราบ";
//       statusColor = "black"; // สีดำสำหรับสถานะที่ไม่ทราบ
//       break;
//   }

//   return (
//     <div>
//       <Link
//         key={order.id}
//         to="/ticketpostpone"
//         state={{ id: order.id,ref1: order.ref1,ref2: order.ref2,status: order.status, ticketstatus: order.action }}
//         onClick={(e) => {
//           if (order.action === "active" || order.status === "cancel") {
//               e.preventDefault(); // ป้องกันการนำทาง
//           }
//       }}
//         className={`status text-primary ${order.action === "finished" || order.status === "cancel" ? "disabledorder" : ""}`} >

//         <div className={`cardContent ${order.action === "finished" || order.status === "cancel" ? "disabledorder" : ""}`}>
//           <div className="row box-card  " style={{ borderRadius: 15 }}>
//             <div className="col-9 col-sm-12 col-md-9 ">
//               <div className="row  ">
//                 <img src={Zpotlogo} alt="Zpot Logo" style={{ width: '80px', height: '60px' }} />
//                 {/* <img src={Addpay} alt="Add Pay" style={{ width: '80px', height: '60px' }}/> */}
//               </div>
//               <h5>{zooname}</h5>
//               <h5>รหัสอ้างอิง: {order.ref1}</h5>
//               <h5 style={{ color: statusColor }}>สถานะบัตร: {statusText}</h5>
//               <p className={order.action === "finished" || order.status === "cancel" ? "disabledText" : ""}>
//               วันที่: {order.postpone === null ? formatDate(order.onDate) : formatDate(order.postpone)}
//               </p>
//               <p className={order.action === "finished" || order.status === "cancel" ? "disabledText" : ""}>
//                 ราคา: {order.amount} บาท
//               </p>
//             </div>
//             <div className="col-3 col-sm-12 col-md-3">
//               <div className="container" style={{ width: '80px', height: '80px' }}>
//                 <img style={{ width: '50px', height: '50px' }} src={zooImg} alt="Zoo" />
//               </div>
//             </div>
//             <div className="col-12 mt-2 border-dark border-top py-2">
//               <div className="d-flex justify-content-between">
//                 <span
//                   className={` ${order.status === 'approved'
//                       ? 'text-success'
//                       : order.status === 'cancel'
//                         ? 'text-danger'
//                         : 'text-warning'
//                     }${order.action === "finished" || order.status === "cancel" ? "disabledText" : ""}`}
//                 >
           
//   สถานะ:  {order.status === 'approved' ? 'ชำระเงินแล้ว' 
//     : order.status === 'pending' ? 'รอชำระเงิน' 
//     : 'ยกเยกรายการ'}
// </span>
//                 {getStatusLink(order.status)}
//               </div>
//             </div>
//           </div>
//         </div>
//       </Link>
//     </div>
//   );
// }

// function OrderList() {
//   const [orders, setOrders] = useState([]);
//   const [error, setError] = useState(null);
//   const [filterStatus, setFilterStatus] = useState('approved'); // ค่าเริ่มต้นเป็น 'approved'
//   const [selectedDate, setSelectedDate] = useState('');
//   const [currentPage, setCurrentPage] = useState(1);
//   const [ordersPerPage] = useState(5); // จำนวนรายการที่ต้องการแสดงต่อหน้า
//   const iduser = localStorage.getItem('userid')
//   const navigate = useNavigate();
//   useEffect(() => {

//     const fetchData = async () => {
//       const formdata = new FormData();
//       const myHeaders = new Headers();
//       myHeaders.append("X-API-KEY", localStorage.getItem('apikey'));
//       formdata.append('user_id', `${iduser}`);

//       const requestOptions = {
//         method: 'POST',
//         body: formdata,
//         headers: myHeaders,
//         redirect: 'follow',
//       };

//       try {
//         const response = await fetch(`${API_ENDPOINT}/api/v1/zoo/e-member/orderList`, requestOptions);

//         if (response.status === 401) {
//           // จัดการกรณี Unauthorized (401)
//           setError('พบปัญหาระหว่างตรวจสอบผู้ใช้งาน กรุณาออกจากระบบและเข้าระบบอีกครั้ง');

//           Swal.fire({
//             icon: 'error',
//             title: 'Unauthorized',
//             text: 'พบปัญหาระหว่างตรวจสอบผู้ใช้งาน กรุณาออกจากระบบและเข้าระบบอีกครั้ง',
//             confirmButtonText: 'ตกลง'
//           }).then(() => {
//             navigate('/home'); // เปลี่ยนเส้นทางไปยังหน้าโฮม
//           });
//           return;
//         }

//         const result = await response.json();

//    console.log(result)
//         const filteredResults = result.filter((item) => {
//           const isDateMatch = selectedDate ? item.onDate === selectedDate : true;
//           return item.status === filterStatus && isDateMatch;
//         });
//         setOrders(filteredResults);
//       } catch (error) {
//         setError('Failed to fetch data');
//         console.error('Error:', error);
//       }
//     };
//     // const fetchData = async () => {
//     //   const formdata = new FormData();
//     //   const myHeaders = new Headers();
//     //   // myHeaders.append("X-API-KEY", localStorage.getItem('apikey'));
//     //   formdata.append('user_id', `${iduser}`);

//     //   const requestOptions = {
//     //     method: 'POST',
//     //     body: formdata,
//     //     headers: myHeaders,
//     //     redirect: 'follow',
//     //   };

//     //   try {
//     //     const response = await fetch(`${API_ENDPOINT}/api/v1/zoo/e-member/orderList`, requestOptions);
//     //     const result = await response.json();
//     //     console.log(result)
//     //     const filteredResults = result.filter((item) => {
//     //       const isDateMatch = selectedDate ? item.onDate === selectedDate : true;
//     //       return item.status === filterStatus && isDateMatch;
//     //     });
//     //     setOrders(filteredResults);

//     //   } catch (error) {
//     //     setError('Failed to fetch data');
//     //     console.error('Error:', error);
//     //   }
//     // };

//     fetchData();
//   }, [filterStatus, selectedDate]);

//   // Pagination Logic
//   const indexOfLastOrder = currentPage * ordersPerPage;
//   const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
//   const currentOrders = orders.slice(indexOfFirstOrder, indexOfLastOrder);

//   const handleFilterStatus = (status) => {
//     setFilterStatus(status);
//   };

//   const handleDateChange = (event) => {
//     setSelectedDate(event.target.value);
//   };

//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   const totalPages = Math.ceil(orders.length / ordersPerPage);

//   // Custom clamp function
//   const clamp = (value, min, max) => Math.max(min, Math.min(value, max));

//   // Calculate the range of pages to display
//   const pageRange = () => {
//     const range = [];
//     const start = clamp(currentPage - 4, 1, totalPages - 9);
//     const end = clamp(start + 9, 5, totalPages);
//     for (let i = start; i <= end; i++) {
//       range.push(i);
//     }
//     return range;
//   };

//   return (
//     <div>
//       <section className="bg-section">
//         <Navbar />


//         {/* <!-- Page Header Start --> */}
//         <div
//           className="container-fluid header-bg py-5 mb-5 wow fadeIn"
//           data-wow-delay="0.1s"
//         >
//           <div className="container text-start py-5">
//             <h1 className="display-4 text-white mb-3 animated slideInDown">
//               รายการจอง
//             </h1>
//             <nav aria-label="breadcrumb animated slideInDown">
//               <ol className="breadcrumb mb-0">
//                 <li className="breadcrumb-item">
//                   <Link className="text-white" to="/">
//                     รายการจอง
//                   </Link>
//                 </li>
//                 <li
//                   className="breadcrumb-item text-primary active"
//                   aria-current="page"
//                 >
//                   รายการจองของคุณ
//                 </li>
//               </ol>
//             </nav>
//           </div>
//         </div>
//         {/* <!-- Page Header End --> */}
//         <div className="container">
//           <div className="py-4 py-md-4 py-lg-5">
//             <div className="toplist box-card py-2 py-md-4 py-lg-5 px-4">
//               {error && <p>{error}</p>}

//               {/* Status Filter */}
//               <div className="mb-3">
//                 <label htmlFor="statusFilter" className="form-label">
//                   เลือกสถานะ:
//                 </label>
//                 <select
//                   id="statusFilter"
//                   className="form-control"
//                   value={filterStatus}
//                   onChange={(e) => handleFilterStatus(e.target.value)}
//                 >
//                   <option value="approved">ชำระเงินแล้ว</option>
//                   <option value="cancel">รายการที่ยกเลิก</option>
//                   <option value="pending">รอชำระเงิน</option>
//                   {/* เพิ่มตัวเลือกสถานะอื่นๆ ได้ที่นี่ */}
//                 </select>
//               </div>

//               {/* Date Filter */}
//               <div className="mb-3">
//                 <label htmlFor="dateFilter" className="form-label">
//                   เลือกวันที่:
//                 </label>
//                 <input
//                   type="date"
//                   id="dateFilter"
//                   className="form-control"
//                   value={selectedDate}
//                   onChange={handleDateChange}
//                 />
//               </div>

//               {/* Tabs Content */}
//               <div className="tab-content mt-3" id="pills-tabContent">
//                 <div
//                   className="tab-pane fade show active"
//                   id="st-panding"
//                   role="tabpanel"
//                   aria-labelledby="-tab"
//                 >
//                   <div className="row">
//                     {currentOrders.map((order) => (
//                       <div key={order.id} className="col-12 col-sm-6 col-lg-4 mb-4">
//                         <OrderItem order={order} />
//                       </div>
//                     ))}
//                   </div>

//                   {/* Pagination Controls */}
//                   <nav aria-label="Page navigation">
//                     <ul className="pagination">
//                       <li className="page-item">
//                         <button
//                           className="page-link"
//                           onClick={() => handlePageChange(currentPage - 1)}
//                           disabled={currentPage === 1}
//                         >
//                           Previous
//                         </button>
//                       </li>
//                       {pageRange().map((number) => (
//                         <li key={number} className="page-item">
//                           <button
//                             className="page-link"
//                             onClick={() => handlePageChange(number)}
//                             aria-current={number === currentPage ? 'page' : undefined}
//                           >
//                             {number}
//                           </button>
//                         </li>
//                       ))}
//                       <li className="page-item">
//                         <button
//                           className="page-link"
//                           onClick={() => handlePageChange(currentPage + 1)}
//                           disabled={currentPage === totalPages}
//                         >
//                           Next
//                         </button>
//                       </li>
//                     </ul>
//                   </nav>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       <Footer></Footer>
//     </div>
//   );
// }

// export default OrderList;






import Swal from 'sweetalert2';
import { useNavigate, Link } from 'react-router-dom';
import Footer from '../navbarv2/footer';
import React, { useState, useEffect } from 'react';
import Navbar from '../navbarv2/navbar';
import Zpotlogo from '../img/ZPOT_LOGO.png';
import imgzoos from '../model/imgmodel';
import { API_ENDPOINT } from '../auth/config';
import { formatDate } from '../FormatDate/formatDate';

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;700&family=Outfit:wght@300;400;500;600&display=swap');

  .order-page {
    min-height: 100vh;
    background: #0a1628;
    color: #f1f5f9;
  }

  /* ── PAGE HEADER ── */
  .order-page-header {
    padding: 52px 40px 36px;
    max-width: 1100px;
    margin: 0 auto;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 16px;
    border-bottom: 1px solid rgba(255,255,255,0.06);
  }

  .order-eyebrow {
    font-size: 0.7rem;
    font-weight: 600;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    color: #22c55e;
    margin-bottom: 6px;
  }

  .order-page-title {
    font-size: clamp(1.7rem, 3vw, 2.4rem);
    font-weight: 700;
    color: #f1f5f9;
    margin: 0;
  }

  .order-count-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 6px 16px;
    background: rgba(34,197,94,0.1);
    border: 1px solid rgba(34,197,94,0.25);
    border-radius: 100px;
    font-size: 0.8rem;
    font-weight: 600;
    color: #22c55e;
  }

  /* ── FILTER BAR ── */
  .order-filter-bar {
    max-width: 1100px;
    margin: 28px auto 0;
    padding: 0 40px;
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
  }

  /* STATUS TABS */
  .filter-tabs {
    display: flex;
    gap: 6px;
    background: rgba(255,255,255,0.03);
    border: 1px solid rgba(255,255,255,0.07);
    border-radius: 14px;
    padding: 5px;
  }

  .filter-tab {
    padding: 9px 18px;
    border-radius: 10px;
    font-size: 0.85rem;
    font-weight: 500;
    color: #64748b;
    background: transparent;
    border: none;
    cursor: pointer;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    gap: 7px;
    white-space: nowrap;
  }

  .filter-tab:hover { color: #f1f5f9; background: rgba(255,255,255,0.05); }

  .filter-tab.active {
    color: #fff;
    background: linear-gradient(135deg, #22c55e, #16a34a);
    box-shadow: 0 2px 12px rgba(34,197,94,0.3);
  }

  .filter-tab.active-cancel {
    color: #fff;
    background: linear-gradient(135deg, #ef4444, #dc2626);
    box-shadow: 0 2px 12px rgba(239,68,68,0.3);
  }

  .filter-tab.active-pending {
    color: #fff;
    background: linear-gradient(135deg, #f59e0b, #d97706);
    box-shadow: 0 2px 12px rgba(245,158,11,0.3);
  }

  .filter-tab-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: currentColor;
    opacity: 0.7;
  }

  /* DATE FILTER */
  .filter-date-wrap {
    display: flex;
    align-items: center;
    gap: 8px;
    background: rgba(255,255,255,0.04);
    border: 1px solid rgba(255,255,255,0.09);
    border-radius: 12px;
    padding: 9px 14px;
    color: #64748b;
    font-size: 0.85rem;
    transition: border-color 0.2s;
  }

  .filter-date-wrap:focus-within {
    border-color: rgba(34,197,94,0.4);
    color: #f1f5f9;
  }

  .filter-date-wrap input[type="date"] {
    background: transparent;
    border: none;
    outline: none;
    color: #94a3b8;
    font-size: 0.85rem;
    cursor: pointer;
  }

  .filter-date-wrap input[type="date"]::-webkit-calendar-picker-indicator {
    filter: invert(0.5);
    cursor: pointer;
  }

  .filter-clear-btn {
    background: none;
    border: none;
    color: #475569;
    cursor: pointer;
    font-size: 1rem;
    padding: 0 0 0 4px;
    line-height: 1;
    transition: color 0.2s;
  }
  .filter-clear-btn:hover { color: #f87171; }

  /* ── ORDER GRID ── */
  .order-grid-wrap {
    max-width: 1100px;
    margin: 32px auto 0;
    padding: 0 40px 80px;
  }

  .order-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
    gap: 18px;
  }

  /* ── ORDER CARD ── */
  .order-card-link {
    text-decoration: none;
    display: block;
  }

  .order-card {
    background: #ffffff;
    border: none;
    border-radius: 16px;
    overflow: hidden;
    transition: transform 0.2s, box-shadow 0.2s;
    cursor: pointer;
    position: relative;
    box-shadow: 0 2px 12px rgba(0,0,0,0.3);
  }

  .order-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 16px 48px rgba(0,0,0,0.4);
  }

  .order-card.disabled {
    opacity: 0.55;
    cursor: not-allowed;
    pointer-events: none;
    filter: grayscale(0.4);
  }

  .order-card.disabled:hover { transform: none; box-shadow: 0 2px 12px rgba(0,0,0,0.3); }

  /* TOP STRIP */
  .order-card-strip {
    height: 5px;
    width: 100%;
  }
  .strip-approved { background: linear-gradient(to right, #16a34a, #22c55e); }
  .strip-pending  { background: linear-gradient(to right, #d97706, #f59e0b); }
  .strip-cancel   { background: linear-gradient(to right, #dc2626, #ef4444); }

  /* CARD HEADER */
  .order-card-head {
    padding: 16px 18px 14px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #04070a;
    background: #f8fafc;
  }

  .order-zoo-identity {
    display: flex;
    align-items: center;
    gap: 11px;
  }

  .order-zoo-logo {
    width: 44px;
    height: 44px;
    object-fit: contain;
    border-radius: 10px;
    background: #ffffff;
    padding: 5px;
    border: 1px solid #e2e8f0;
    flex-shrink: 0;
    box-shadow: 0 1px 4px rgba(0,0,0,0.08);
  }

  .order-zoo-name {
    font-size: 0.95rem;
    font-weight: 700;
    color: #0f172a;
    line-height: 1.3;
  }

  .order-zoo-sub {
    font-size: 0.7rem;
    color: #94a3b8;
    margin-top: 2px;
    font-weight: 400;
  }

  /* PAYMENT STATUS BADGE */
  .order-pay-badge {
    padding: 5px 13px;
    border-radius: 100px;
    font-size: 0.73rem;
    font-weight: 700;
    white-space: nowrap;
    letter-spacing: 0.03em;
  }

  .badge-approved { background: #dcfce7; color: #15803d; border: 1.5px solid #86efac; }
  .badge-pending  { background: #fef9c3; color: #92400e; border: 1.5px solid #fde68a; }
  .badge-cancel   { background: #fee2e2; color: #b91c1c; border: 1.5px solid #fca5a5; }

  /* CARD BODY */
  .order-card-body {
    padding: 14px 18px 16px;
    display: flex;
    flex-direction: column;
    gap: 0;
    background: #ffffff;
  }

  .order-info-row {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 9px 0;
    border-bottom: 1px solid #f1f5f9;
  }

  .order-info-row:last-child { border-bottom: none; }

  .order-info-icon {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    background: #f0fdf4;
    border: 1.5px solid #bbf7d0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.8rem;
    flex-shrink: 0;
  }

  .order-info-label {
    font-size: 0.68rem;
    color: #94a3b8;
    margin-bottom: 2px;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    font-weight: 600;
  }

  .order-info-value {
    font-size: 0.9rem;
    color: #334155;
    font-weight: 500;
    line-height: 1.3;
  }

  .order-info-value.highlight {
    color: #0f172a;
    font-weight: 700;
    font-size: 0.92rem;
    letter-spacing: 0.01em;
  }

  /* TICKET STATUS */
  .order-ticket-status {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 11px;
    border-radius: 8px;
    font-size: 0.78rem;
    font-weight: 700;
  }

  .ticket-unused  { background: #dcfce7; color: #15803d; border: 1.5px solid #86efac; }
  .ticket-active  { background: #fef9c3; color: #92400e; border: 1.5px solid #fde68a; }
  .ticket-used    { background: #f1f5f9; color: #64748b; border: 1.5px solid #cbd5e1; }

  /* CARD FOOTER */
  .order-card-foot {
    padding: 13px 18px;
    background: #f8fafc;
    border-top: 1px solid #f1f5f9;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .order-price {
    font-size: 1.3rem;
    font-weight: 800;
    color: #0f172a;
    letter-spacing: -0.02em;
  }

  .order-price span {
    font-size: 0.8rem;
    color: #94a3b8;
    font-weight: 500;
    margin-left: 4px;
  }

  .order-arrow-btn {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 0.82rem;
    font-weight: 700;
    color: #15803d;
    background: #dcfce7;
    border: 1.5px solid #86efac;
    padding: 7px 16px;
    border-radius: 9px;
    transition: all 0.2s;
  }

  .order-card:hover .order-arrow-btn {
    background: #16a34a;
    color: #ffffff;
    border-color: #16a34a;
    gap: 9px;
  }

  .order-card.disabled .order-arrow-btn {
    background: #f1f5f9;
    color: #94a3b8;
    border-color: #e2e8f0;
  }

  /* ── EMPTY STATE ── */
  .order-empty {
    grid-column: 1 / -1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 80px 20px;
    text-align: center;
  }

  .order-empty-icon {
    font-size: 3rem;
    margin-bottom: 16px;
    opacity: 0.4;
  }

  .order-empty-text {
    font-size: 1rem;
    color: #475569;
  }

  /* ── LOADING SKELETON ── */
  .order-skeleton {
    background: rgba(15,23,42,0.75);
    border: 1px solid rgba(255,255,255,0.05);
    border-radius: 18px;
    overflow: hidden;
    height: 220px;
  }

  .skeleton-shimmer {
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, rgba(255,255,255,0.03) 25%, rgba(255,255,255,0.07) 50%, rgba(255,255,255,0.03) 75%);
    background-size: 200% 100%;
    animation: shimmer 1.5s infinite;
  }

  @keyframes shimmer {
    0% { background-position: -200% 0; }
    100% { background-position: 200% 0; }
  }

  /* ── PAGINATION ── */
  .order-pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    margin-top: 36px;
    flex-wrap: wrap;
  }

  .page-btn {
    width: 38px;
    height: 38px;
    border-radius: 10px;
    background: rgba(255,255,255,0.04);
    border: 1px solid rgba(255,255,255,0.07);
    color: #64748b;
    font-size: 0.875rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .page-btn:hover:not(:disabled) {
    background: rgba(255,255,255,0.08);
    color: #f1f5f9;
    border-color: rgba(255,255,255,0.15);
  }

  .page-btn.active {
    background: linear-gradient(135deg, #22c55e, #16a34a);
    border-color: transparent;
    color: #fff;
    box-shadow: 0 2px 12px rgba(34,197,94,0.35);
  }

  .page-btn:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }

  .page-btn-wide {
    width: auto;
    padding: 0 14px;
    gap: 6px;
  }

  /* RESPONSIVE */
  @media (max-width: 600px) {
    .order-page-header, .order-filter-bar, .order-grid-wrap { padding-left: 16px; padding-right: 16px; }
    .filter-tabs { flex-wrap: wrap; }
    .order-grid { grid-template-columns: 1fr; }
  }
`;

/* ─────────────────── ORDER CARD ─────────────────── */
function OrderItem({ order }) {
  const foundZoo = order.zoo_id ? imgzoos.find(z => z.id === order.zoo_id) : null;
  const zooImg  = foundZoo?.img  ?? null;
  const zooname = foundZoo?.name ?? 'องค์การสวนสัตว์แห่งประเทศไทย';

  const isDisabled = order.action === 'finished' || order.status === 'cancel';
  const isActive   = order.action === 'active';

  const ticketInfo = (() => {
    if (order.action === null)       return { label: 'ยังไม่ได้ใช้',    cls: 'ticket-unused',  icon: '🎫' };
    if (order.action === 'active')   return { label: 'กำลังใช้งาน',    cls: 'ticket-active',  icon: '⚡' };
    if (order.action === 'finished') return { label: 'ใช้งานแล้ว',     cls: 'ticket-used',    icon: '✓'  };
    return                                  { label: 'ไม่ทราบสถานะ',   cls: 'ticket-used',    icon: '?'  };
  })();

  const payBadge = (() => {
    if (order.status === 'approved') return { label: 'ชำระแล้ว',       cls: 'badge-approved' };
    if (order.status === 'pending')  return { label: 'รอชำระเงิน',     cls: 'badge-pending'  };
    return                                  { label: 'ยกเลิกแล้ว',     cls: 'badge-cancel'   };
  })();

  const stripCls = order.status === 'approved' ? 'strip-approved'
                 : order.status === 'pending'  ? 'strip-pending'
                 : 'strip-cancel';

  const displayDate = order.postpone ? formatDate(order.postpone) : formatDate(order.onDate);

  const handleClick = (e) => {
    if (isActive || order.status === 'cancel') e.preventDefault();
  };

  const cardContent = (
    <div className={`order-card${isDisabled ? ' disabled' : ''}`}>
      <div className={`order-card-strip ${stripCls}`} />

      {/* HEAD */}
      <div className="order-card-head">
        <div className="order-zoo-identity">
          {zooImg
            ? <img src={zooImg} alt={zooname} className="order-zoo-logo" />
            : <img src={Zpotlogo} alt="Zoo" className="order-zoo-logo" />
          }
          <div>
            <div className="order-zoo-name">{zooname}</div>
            <div className="order-zoo-sub">Zoo e-Ticket</div>
          </div>
        </div>
        <span className={`order-pay-badge ${payBadge.cls}`}>{payBadge.label}</span>
      </div>

      {/* BODY */}
      <div className="order-card-body">
        <div className="order-info-row">
          <div className="order-info-icon">🔖</div>
          <div>
            <div className="order-info-label">รหัสอ้างอิง</div>
            <div className="order-info-value highlight">{order.ref1}</div>
          </div>
        </div>

        <div className="order-info-row">
          <div className="order-info-icon">📅</div>
          <div>
            <div className="order-info-label">วันที่ใช้งาน</div>
            <div className="order-info-value">{displayDate}</div>
          </div>
        </div>

        <div className="order-info-row">
          <div className="order-info-icon">🎟</div>
          <div>
            <div className="order-info-label">สถานะบัตร</div>
            <span className={`order-ticket-status ${ticketInfo.cls}`}>
              {ticketInfo.icon} {ticketInfo.label}
            </span>
          </div>
        </div>
      </div>

      {/* FOOTER */}
      <div className="order-card-foot">
        <div className="order-price">
          {Number(order.amount).toLocaleString()}
          <span>บาท</span>
        </div>
        {!isDisabled && (
          <div className="order-arrow-btn">
            ดูรายการ <span>→</span>
          </div>
        )}
      </div>
    </div>
  );

  if (isDisabled) return cardContent;

  return (
    <Link
      to="/ticketpostpone"
      state={{ id: order.id, postpone: order.postpone, ref1: order.ref1, ref2: order.ref2, status: order.status, ticketstatus: order.action }}
      onClick={handleClick}
      className="order-card-link"
    >
      {cardContent}
    </Link>
  );
}

/* ─────────────────── ORDER LIST PAGE ─────────────────── */
function OrderList() {
  const [orders, setOrders]           = useState([]);
  const [loading, setLoading]         = useState(true);
  const [error, setError]             = useState(null);
  const [filterStatus, setFilterStatus] = useState('approved');
  const [selectedDate, setSelectedDate] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const ordersPerPage = 6;
  const iduser  = localStorage.getItem('userid');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const formdata = new FormData();
      const myHeaders = new Headers();
      myHeaders.append("X-API-KEY", localStorage.getItem('apikey'));
      formdata.append('user_id', `${iduser}`);

      try {
        const response = await fetch(`${API_ENDPOINT}/api/v1/zoo/e-member/orderList`, {
          method: 'POST', body: formdata, headers: myHeaders, redirect: 'follow',
        });

        if (response.status === 401) {
          setError('พบปัญหาระหว่างตรวจสอบผู้ใช้งาน กรุณาออกจากระบบและเข้าระบบอีกครั้ง');
          Swal.fire({ icon: 'error', title: 'Unauthorized', text: 'กรุณาออกจากระบบและเข้าระบบอีกครั้ง', confirmButtonText: 'ตกลง' })
            .then(() => navigate('/home'));
          return;
        }

        const result = await response.json();
        const filtered = result.filter(item => {
          const dateMatch = selectedDate ? item.onDate === selectedDate : true;
          return item.status === filterStatus && dateMatch;
        });
        setOrders(filtered);
        setCurrentPage(1);
      } catch (err) {
        setError('ไม่สามารถโหลดข้อมูลได้ กรุณาลองใหม่อีกครั้ง');
        console.error('Error:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [filterStatus, selectedDate]);

  const totalPages   = Math.ceil(orders.length / ordersPerPage);
  const currentOrders = orders.slice((currentPage - 1) * ordersPerPage, currentPage * ordersPerPage);

  const clamp = (v, mn, mx) => Math.max(mn, Math.min(v, mx));
  const pageRange = () => {
    const range = [];
    const start = clamp(currentPage - 4, 1, Math.max(1, totalPages - 9));
    const end   = clamp(start + 9, 1, totalPages);
    for (let i = start; i <= end; i++) range.push(i);
    return range;
  };

  const tabs = [
    { value: 'approved', label: 'ชำระแล้ว',     activeClass: 'active',         icon: '✓' },
    { value: 'pending',  label: 'รอชำระเงิน',   activeClass: 'active-pending',  icon: '⏳' },
    { value: 'cancel',   label: 'ยกเลิกแล้ว',   activeClass: 'active-cancel',   icon: '✕' },
  ];

  return (
    <>
      <style>{styles}</style>
      <div className="order-page">
        <Navbar />

        {/* PAGE HEADER */}
        <div className="order-page-header">
          <div>
            <div className="order-eyebrow">บัญชีของฉัน</div>
            <h1 className="order-page-title">รายการจอง</h1>
          </div>
          {!loading && (
            <div className="order-count-badge">
              🎫 {orders.length} รายการ
            </div>
          )}
        </div>

        {/* FILTER BAR */}
        <div className="order-filter-bar">
          {/* STATUS TABS */}
          <div className="filter-tabs">
            {tabs.map(t => (
              <button
                key={t.value}
                className={`filter-tab${filterStatus === t.value ? ` ${t.activeClass}` : ''}`}
                onClick={() => { setFilterStatus(t.value); setCurrentPage(1); }}
              >
                <span>{t.icon}</span>
                {t.label}
              </button>
            ))}
          </div>

          {/* DATE FILTER */}
          <div className="filter-date-wrap">
            <span>📅</span>
            <input
              type="date"
              value={selectedDate}
              onChange={e => { setSelectedDate(e.target.value); setCurrentPage(1); }}
            />
            {selectedDate && (
              <button className="filter-clear-btn" onClick={() => setSelectedDate('')}>✕</button>
            )}
          </div>
        </div>

        {/* GRID */}
        <div className="order-grid-wrap">
          <div className="order-grid">
            {loading ? (
              Array.from({ length: 6 }).map((_, i) => (
                <div key={i} className="order-skeleton">
                  <div className="skeleton-shimmer" />
                </div>
              ))
            ) : error ? (
              <div className="order-empty">
                <div className="order-empty-icon">⚠️</div>
                <div className="order-empty-text">{error}</div>
              </div>
            ) : currentOrders.length === 0 ? (
              <div className="order-empty">
                <div className="order-empty-icon">🎫</div>
                <div className="order-empty-text">ไม่พบรายการจองในสถานะนี้</div>
              </div>
            ) : (
              currentOrders.map(order => (
                <OrderItem key={order.id} order={order} />
              ))
            )}
          </div>

          {/* PAGINATION */}
          {!loading && totalPages > 1 && (
            <div className="order-pagination">
              <button
                className="page-btn page-btn-wide"
                onClick={() => setCurrentPage(p => p - 1)}
                disabled={currentPage === 1}
              >
                ← ก่อนหน้า
              </button>

              {pageRange().map(n => (
                <button
                  key={n}
                  className={`page-btn${n === currentPage ? ' active' : ''}`}
                  onClick={() => setCurrentPage(n)}
                >
                  {n}
                </button>
              ))}

              <button
                className="page-btn page-btn-wide"
                onClick={() => setCurrentPage(p => p + 1)}
                disabled={currentPage === totalPages}
              >
                ถัดไป →
              </button>
            </div>
          )}
        </div>

        <Footer />
      </div>
    </>
  );
}

export default OrderList;